import { getEnvVar } from "utils/environment";

import * as S from './styles'

export const PageUnavailableMessage = () => {
  const message = getEnvVar('MAINTENANCE_MESSAGE')
  
  return (
    <>
      <S.PageUnavailableWrapper>
        <S.MessageBody dangerouslySetInnerHTML={{ __html: message }} />
      </S.PageUnavailableWrapper>
    </>
  )
}